import { render, staticRenderFns } from "./AddCampaignMessage.vue?vue&type=template&id=46417c02&scoped=true&"
import script from "./AddCampaignMessage.vue?vue&type=script&lang=js&"
export * from "./AddCampaignMessage.vue?vue&type=script&lang=js&"
import style0 from "./AddCampaignMessage.vue?vue&type=style&index=0&id=46417c02&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46417c02",
  null
  
)

export default component.exports